var map = {
	"./actions": 5685,
	"./actions.json": 5685,
	"./alert": 3240,
	"./alert.json": 3240,
	"./attributes": 1775,
	"./attributes.json": 1775,
	"./common": 859,
	"./common.json": 859,
	"./competition": 9553,
	"./competition.json": 9553,
	"./confirm-password": 3024,
	"./confirm-password.json": 3024,
	"./contact": 9646,
	"./contact.json": 9646,
	"./costs": 2720,
	"./costs.json": 2720,
	"./dashboard": 3998,
	"./dashboard.json": 3998,
	"./deposit": 6404,
	"./deposit.json": 6404,
	"./forgot-password": 2561,
	"./forgot-password.json": 2561,
	"./forms": 761,
	"./forms.json": 761,
	"./game": 2880,
	"./game.json": 2880,
	"./global": 1185,
	"./global.json": 1185,
	"./home": 4985,
	"./home.json": 4985,
	"./infos-modal": 7707,
	"./infos-modal.json": 7707,
	"./messages": 9458,
	"./messages.json": 9458,
	"./party": 8834,
	"./party.json": 8834,
	"./profile": 6103,
	"./profile.json": 6103,
	"./pwa": 1370,
	"./pwa.json": 1370,
	"./referral": 2795,
	"./referral.json": 2795,
	"./replay-game": 1846,
	"./replay-game.json": 1846,
	"./report-problem": 3738,
	"./report-problem.json": 3738,
	"./settings": 5919,
	"./settings.json": 5919,
	"./sidebar": 5722,
	"./sidebar.json": 5722,
	"./signin": 2220,
	"./signin.json": 2220,
	"./signup": 7006,
	"./signup.json": 7006,
	"./terms": 2365,
	"./terms.json": 2365,
	"./tips": 8704,
	"./tips.json": 8704,
	"./transaction": 6866,
	"./transaction.json": 6866,
	"./withdrawal": 4769,
	"./withdrawal.json": 4769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4049;